import React from 'react'
import {Button, PageHeader, Table} from 'antd'

import requestHandler from 'utils/requestHandler'

const TableWithPageHeader = (
  {
    children,
    service,
    title,
    subtitle,
    extra,
    exportService,
    dataHandler,
    detail,
    detailCustomBttn,
    columns,
    pagination = true, // set to false to disable pagination, set to null to hide completely
    descendant,
    filter,
    refresh = true,
    rowKey,
  },
) => {
  const [data, setData] = React.useState(undefined)
  const [loading, setLoading] = React.useState(false)
  const [params, setParams] = React.useState({})
  const [total, setTotal] = React.useState(0)
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([])

  React.useEffect(() => {
    setParams({page: 0, filter: filter})
  }, [filter, refresh])

  React.useEffect(() => {
    if (Object.entries(params).length) {
      setLoading(true)
      requestHandler(() => service(params.page, params.filter), 'json')
        .then(response => {
          if (response?.data?.items) {
            setTotal(response.data.total)
            setData(dataHandler ? dataHandler(response.data) : response.data.items)
          } else {
            setData(null)
          }
          setLoading(false)
        })
    }
  }, [params, dataHandler, service])

  return (
    <>
      <PageHeader title={title} subTitle={subtitle} extra={[
        extra,
        exportService && (selectedRowKeys.length ? (
          <Button key={1} type='primary' onClick={() => alert('Work in progress')}>Export selected</Button>
        ) : (
          <Button key={1} type='primary' onClick={() => alert('Work in progress')}>Export all</Button>
        )),
      ]}/>

      {children}

      {data === null ? (
        'error'
      ) : (
        <Table
          rowKey={rowKey ? rowKey : 'uuid'}
          size={descendant ? 'middle' : 'default'}
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={typeof pagination === 'boolean' ? {
            onChange: p => setParams({...params, page: p - 1}),
            current: (params.page + 1),
            total: total,
            disabled: !pagination,
          } : pagination === null ? false : pagination}
          rowSelection={{selectedRowKeys, onChange: setSelectedRowKeys}}
          scroll={{x: 'max-content'}}
          expandRowByClick={!!detailCustomBttn}
          expandIconAsCell={!detailCustomBttn}
          expandIcon={detailCustomBttn ? () => <></> : undefined}
          expandedRowRender={detail ? rowElement => detail(rowElement) : undefined}
        />
      )}
    </>
  )
}

export default TableWithPageHeader
